import { render, staticRenderFns } from "./year-range.vue?vue&type=template&id=009f132b"
import script from "./year-range.vue?vue&type=script&lang=js"
export * from "./year-range.vue?vue&type=script&lang=js"
import style0 from "./year-range.vue?vue&type=style&index=0&id=009f132b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports